import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

import LeaveButton from '../../../components/LeaveButton';
import { VaccineIcon } from '../../../assets/icons';

interface Props {
  isRefund?: boolean;
}

const OpenVaccine = ({ isRefund }: Props) => {
  const classes = useStyles();

  return (
    <Grid container className={classes.container}>
      <Grid item>
        <Box px={2} className={classes.disclaimer}>
          <img src={VaccineIcon} alt="vaccine-icon" />
          <Typography variant="h2">Vacinação em aberto!</Typography>
        </Box>
      </Grid>
      <Grid item>
        <Container maxWidth="sm" className={classes.infoContent}>
          {!isRefund ? (
            <Typography>
              No caso de dúvidas, entre em contato com o <strong>ENLACE</strong>{' '}
              através do telefone <strong>0800 709 2364</strong> para consultar
              disponibilidade da vacina contra gripe.
            </Typography>
          ) : (
            <Typography>
              No caso de dúvidas, entre em contato com o <strong>ENLACE</strong>{' '}
              através do telefone <strong>0800 709 2364</strong> para mais
              informações referentes ao reembolso de até R$65,00.
            </Typography>
          )}
        </Container>
      </Grid>
      <LeaveButton className={classes.leaveButton} />
    </Grid>
  );
};

export default OpenVaccine;

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    container: {
      flexDirection: 'column',
      [theme.breakpoints.only('xs')]: {
        minHeight: '80vh',
      },
    },

    disclaimer: {
      textAlign: 'center',
      '& h2': {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1),
        color: theme.palette.primary.main,
        fontSize: 24,
        fontWeight: 'bold',
      },
    },

    content: {
      '& > h2': {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1),
        color: theme.palette.primary.main,
        fontSize: 24,
        fontWeight: 'bold',
      },
    },

    infoContent: {
      marginTop: theme.spacing(10),
      padding: theme.spacing('auto', 3),
      textAlign: 'center',
    },

    leaveButton: {
      bottom: 10,
    },
  })
);
